<div class="main-wrapper-section">
    <div class="common-header" *ngIf="!isContact">
        <h3>Cases</h3>
        <div>
            <button class="primary-btn" style="min-width:100px" [routerLink]="['/mem-case']">Add</button>
        </div>
    </div>
    <div class="card-section">
        <div class="card-panel">
            <div *ngIf="!isContact">

                <div class="field-form-panel">
                    <div class="flex-form contracts-flex-form">
                        <div class="form-group">
                            <label>Site</label>
                            <select [(ngModel)]="selectedCMSiteID" (change)="onChangeCMSite()" class="form-control" name="sites">
                                <option value="0">--ALL--</option>
                                <option *ngFor="let opt of cmSites" [value]="opt.siteID">
                                    {{ opt.siteName }}
                                </option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label>Manager</label>
                            <select [(ngModel)]="selectedUserID" (change)="onChangeUserDD()" class="form-control" name="manager">
                                <option *ngFor="let opt of clpUsersDD" [value]="opt.value">
                                    {{ opt.text }}
                                </option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label>Case Status</label>
                            <select [(ngModel)]="caseStatusID" (change)="onChangeStatus()" class="form-control" name="status">
                                <option value="0">--ALL--</option>
                                <option *ngFor="let opt of ref_MemCaseStatus_List" [value]="opt.statusID">
                                    {{ opt.status }}
                                </option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label>Case Reason</label>
                            <select [(ngModel)]="caseReasonID" (change)="onChangeCaseReason()" class="form-control" name="caseReasonID">
                                <option value="0">--ALL--</option>
                                <option *ngFor="let opt of ref_MemCaseReason_List" [value]="opt.reasonID">
                                    {{ opt.reason }}
                                </option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label>Case Origin </label>
                            <select [(ngModel)]="caseOriginID" (change)="onChangeCaseOrigin()" class="form-control" name="caseOrigin">
                                <option value="0">--ALL--</option>
                                <option *ngFor="let opt of ref_MemCaseOrigin_List" [value]="opt.originID">
                                    {{ opt.origin }}
                                </option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label *ngIf="selectedCtDtFilter == 1 || selectedCtDtFilter == 2">Time Frame</label>
                            <div *ngIf="selectedCtDtFilter == 1 || selectedCtDtFilter == 2">
                                <select [(ngModel)]="selectedCtDtFilter" (change)="createDtFilterChange($event)" class="form-control" name="status">
                                    <option *ngFor="let opt of createDateFilters" [value]="opt.value">
                                        {{ opt.name }}
                                    </option>
                                </select>
                            </div>
                            <div class="custom-date" *ngIf="selectedCtDtFilter == 3 || selectedCtDtFilter == 4 || selectedCtDtFilter == 5 || selectedCtDtFilter == 6" style="margin-top: -3px;">
                                <label>Custom Range</label>
                                <div class="display-row">
                                    <mat-form-field appearance="outline">
                                        <mat-date-range-input [rangePicker]="dateRangePicker" [formGroup]="currentRange" readonly>
                                            <input matStartDate placeholder="Start date" formControlName="start" #dateRangeStart readonly>
                                            <input matEndDate placeholder="End date" formControlName="end" #dateRangeEnd (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)" readonly>
                                        </mat-date-range-input>
                                        <mat-datepicker-toggle class="custom-daterange-toggle" matPrefix [for]="dateRangePicker"></mat-datepicker-toggle>
                                        <mat-date-range-picker #dateRangePicker></mat-date-range-picker>
                                        <span *ngIf="currentRange.controls.start.hasError('matStartDateInvalid')"><mat-error>Invalid start date</mat-error></span>
                                        <span *ngIf="currentRange.controls.end.hasError('matEndDateInvalid')"><mat-error>Invalid end date</mat-error></span>
                                    </mat-form-field>
                                    <i class="fa fa-undo" (click)="revertCustomFinalizeddtFilter()" style="font-size:20px; margin-left:10px;"></i>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label>Search</label>
                            <div class="button-group">
                                <input matInput class="form-control" (keyup)="applyFilter($event.target.value)" placeholder="Search">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="table-panel">
                <div class="table-body">
                    <table mat-table [dataSource]="dataSource" class="contracts-table" matSort *ngIf="dataSource?.data">
                        <ng-container matColumnDef="position">
                            <th mat-header-cell *matHeaderCellDef></th>
                            <td mat-cell *matCellDef="let row; let i = index"><div class="members-name">{{ i + 1 }}</div></td>
                        </ng-container>
                        <ng-container matColumnDef="contactName">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
                            <td mat-cell *matCellDef="let element"><a href="javascript:void(0)" (click)="navToMemContact(element?.contactID)">{{element.contactName}}</a></td>
                        </ng-container>
                        <ng-container matColumnDef="caseNumber">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Case Number</th>
                            <td mat-cell *matCellDef="let element"> <div class="members-name">{{element.caseNumber}}</div></td>
                        </ng-container>
                        <ng-container matColumnDef="subject">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Subject</th>
                            <td mat-cell *matCellDef="let element"><div class="members-product">{{element.subject}}</div></td>
                        </ng-container>
                        <ng-container matColumnDef="dtOpened">
                            <th mat-header-cell *matHeaderCellDef>Open Date</th>
                            <td mat-cell *matCellDef="let element"><div class="members-site">{{formatDate(element.dtOpened)}}</div></td>
                        </ng-container>
                        <ng-container matColumnDef="dtClosed">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Closed Date</th>
                            <td mat-cell *matCellDef="let element"><div class="members-status">{{formatDate(element.dtClosed)}}</div></td>
                        </ng-container>
                        <ng-container matColumnDef="caseReason">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Case Reason</th>
                            <td mat-cell *matCellDef="let element"><div class="members-date">{{element.caseReason}}</div></td>
                        </ng-container>
                        <ng-container matColumnDef="caseResolution">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Case Resolution</th>
                            <td mat-cell *matCellDef="let element"><div class="members-date">{{element.caseResolution}}</div></td>
                        </ng-container>
                        <ng-container matColumnDef="caseStatus">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Case Status</th>
                            <td mat-cell *matCellDef="let element"><div class="members-date">{{element.caseStatus}}</div></td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selectRow(row)">
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>


<div id="showCaseModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="mobileOptLogModalLabel" aria-hidden="true" data-focus="false">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4>Case</h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <app-mem-case *ngIf="user && showCaseModal" [caseID]="selectedCaseID" [contactId]="contactId" [isContact]="isContact" (isCloseButton)="hideShowCaseModal($event)"></app-mem-case>
            </div>
            <!--<div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            </div>-->
        </div>
    </div>
</div>

